<template>
  <div
    data-qa="member_card"
    class="d-flex pa-3 gc-6 gr-3 bg-secondary rounded"
    :class="{ 'flex-column': isMobile }"
  >
    <div class="d-flex gc-6 align-center">
      <v-img
        data-qa="member_card_img"
        :src="member.photo?.url || '/static/_v1/pd/pictures/stubs/person-photo.png'"
        lazy-src="/static/_v1/pd/pictures/stubs/person-photo.png"
        :alt="t('Фото представителя', options)"
        class="flex-grow-0 rounded-circle"
        :width="isMobile ? 80 : 150"
        :height="isMobile ? 80 : 150"
      />
      <div
        v-if="isMobile"
        class="d-flex flex-column"
      >
        <div
          data-qa="member_card_fio"
          class="text-body-1 text--text"
        >
          {{ member.last_name }} <br>
          {{ member.first_name }} {{ member.second_name }}
        </div>
        <div
          v-if="context.feature_flags.update_ethical_commission_page && member.ethical_commission_member_grade"
          data-qa="member_card_role"
          class="text-body-2 text--text"
        >
          {{ t(member.ethical_commission_member_grade, options) }}
        </div>
      </div>
    </div>

    <v-divider
      v-if="isMobile && member.occupations.length"
      class="mb-3"
    />

    <div class="d-flex flex-column ga-3 w-100">
      <div
        v-if="!isMobile"
        class="d-flex flex-column"
      >
        <div
          data-qa="member_card_fio"
          class="text-body-1 text--text"
        >
          {{ member.last_name }} <br>
          {{ member.first_name }} {{ member.second_name }}
        </div>
        <div
          v-if="context.feature_flags.update_ethical_commission_page && memberGradeText"
          data-qa="member_card_role"
          class="text-body-2 text--text"
        >
          {{ t(memberGradeText, options) }}
        </div>
      </div>

      <template v-if="member.occupations.length > 0">
        <v-divider
          v-if="!isMobile"
          class="my-3"
        />
        <ul
          v-if="member.occupations.length > 1"
          class="text-body-2 text--text ml-3"
        >
          <li
            v-for="occupation in member.occupations"
            :key="occupation"
            class="ml-3"
          >
            {{ occupation }}
          </li>
        </ul>
        <div
          v-else
          class="text-body-2 text--text"
        >
          {{ member.occupations[0] }}
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ContextStore, EthicalCommissionMember } from 'src/components/pages/info/ethical-commission/index/types'
import { useContextStore } from 'src/store'
import { computed } from 'vue'
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  member: EthicalCommissionMember
}>()

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')

const memberGradeText = computed(() => {
  switch (props.member.ethical_commission_member_grade) {
    case 'reviewer':
      return 'Рецензент'
    case 'expert':
      return 'Эксперт'
    default:
      return ''
  }
})
</script>
